import MDBox from "shared/components/MDBox";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import Footer from "app/layout/Footer";
import IndicadoresPanel from "./components/IndicadoresPanel";
import { useIndicadores } from "./hooks/useIndicadores";

export default function Indicadores() {
  const state = useIndicadores();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <IndicadoresPanel state={state} />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
